import { get, computed } from '@ember/object';

export default function computedFirst(key: string, count: number) {
  return computed(key, function () {
    return (get(this, key) ?? []).slice(0, count);
  });
}
